<template>
    <el-popover ref="myPopover" placement="bottom-start" width="234" trigger="click" @show="checkedDefault">
      <div class="icon-panel">
        <div class="icons">
          <div class="icons-item" @click="checkedIcon(item)" :class="defIcon === item ? 'active' : ''" v-for="item in icons" :key="item">
            <i class="iconfont" :class="item"></i>
          </div>
        </div>
        <div class="colors">
          <div class="colors-item" @click="checkedColor(item)" :class="defColor === item ? 'active' : ''" v-for="item in colors" :key="item" :style="{background: item}"></div>
        </div>
        <div class="submit">
          <el-button type="text" @click="confirm">确定</el-button>
          <el-button type="text" @click="cancel">取消</el-button>
        </div>
      </div>
      <slot slot="reference"></slot>
    </el-popover>
</template>

<script>
export default {
  name: "iconPanel",
  props: {
    iconInfo: {
      type: Object,
      default: ()=>{
        return {}
      }
    }
  },
  data() {
    return {
      icons: [
        'iconhangzheng',
        'iconfeiji',
        'iconmeiti',
        'iconwaimai',
        'iconwuliu1',
        'iconchengshi1',
        'icondapingmu',
        'iconwurenji',
      ],
      colors: [
        '#E25359',
        '#FFA350',
        '#CE50FF',
        '#509AFF',
        '#00B97E',
        'initial'
      ],
      defIcon: '',
      defColor: ''
    }
  },
  methods: {
    checkedDefault() {
      this.defIcon = this.iconInfo.icon;
      this.defColor = this.iconInfo.icon_color
    },
    checkedIcon(item) {
      this.defIcon = item;
    },
    checkedColor(item) {
      this.defColor = item;
    },
    confirm() {
      // TODO: 确认选择后,提交一个事件
      this.iconInfo.icon = this.defIcon;
      this.iconInfo.icon_color = this.defColor;
      this.$refs['myPopover'].doClose();
      this.$emit("changeIcon", {
        project_list_id: this.iconInfo.project_list_id,
        icon: this.defIcon,
        icon_color: this.defColor
      })
    },
    cancel() {
      this.$refs['myPopover'].doClose();
      this.checkedDefault()
    }
  },
  watch: {
    iconInfo: {
      handler: function(newVal) {
        this.checkedDefault()
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-panel {
  background: #FFFFFF;
  border-radius: 4px;
  .icons, .colors {
    padding: 16px;
    display: flex;
    flex-wrap: wrap;
  }
  .icons {
    border-bottom: 1px solid #F8F9FB;
  }
  .icons-item {
    cursor: pointer;
    width: 28px;
    height: 28px;
    border: 1px solid rgba(25,24,67,0.08);
    text-align: center;
    line-height: 28px;
    background: #FFFFFF;
    border-radius: 4px;
    margin-bottom: 10px;
    margin-right: 10px;
  }
  .icons-item.active {
    background: #509AFF;
    color: #fff;
  }
  .colors-item {
    position: relative;
    cursor: pointer;
    width: 28px;
    height: 28px;
    border-radius: 4px;
    margin-right: 10px;
    margin-bottom: 10px;
  }
  .colors-item.active::after {
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    content: "";
    width: 5px;
    height: 12px;
    border: 1px solid #FFFFFF;
    border-width: 2px;
    position: absolute;
    transform-origin: center;
    transform: rotate(45deg);
    top: 5px;
    left: 12px;
    border-left: 0;
    border-top: 0;
    transition: transform .15s ease-in .05s;
    transition: transform .15s ease-in .05s, -webkit-transform .15s ease-in .05s;
  }
  .submit {
    padding: 0 16px;
    text-align: right;
  }
}
</style>
